<mat-dialog-content>
  <form [formGroup]="icaBaseForm">
    <div class="row">
      <div class="col-md-4">
        <span>{{ 'City' | translate }}:</span>
        <input class="form-control" [value]="cityName" readonly disabled />
      </div>
      <div class="col-md-4">
        <span>{{ 'Type' | translate }}:</span>
        <input
          class="form-control"
          [value]="typeDescription"
          readonly
          disabled
        />
      </div>
      <div class="col-md-4">
        <span>UVT:</span>
        <input
          class="form-control"
          type="number"
          placeholder="UVT"
          formControlName="uvt"
        />
        @if (textValid('uvt')) {
          <span class="form-text text-danger">{{
            'tributary.common.uvtRequired' | translate
          }}</span>
        }
      </div>
    </div>
    <div class="row dialog-actions">
      <div class="col action-button">
        <button (click)="update()" mat-raised-button>
          {{ 'Update' | translate }}
        </button>
      </div>
      <div class="col action-button">
        <button mat-raised-button [mat-dialog-close]>
          {{ 'Cancel' | translate }}
        </button>
      </div>
    </div>
  </form>
</mat-dialog-content>

<ngx-spinner
  type="ball-scale-multiple"
  template="<img src='../../../../../../assets/gif/V1-Insight-Icon-for-gif-2.gif' />"
  bdColor="rgba(51,51,51,0.8)"
>
  <p class="spinner-message">{{ 'Loading...' | translate }}</p>
</ngx-spinner>
